"use client";
import { Select, SelectProps } from "antd";
import React from "react";
import style from "../style.module.scss";
import { useRetrieveTitle } from "@/Utils/helpers";

interface selectorProps extends SelectProps {
  title: string;
}

const FormSelector: React.FC<selectorProps> = ({ title, ...props }) => {
  const { direction } = useRetrieveTitle();
  return (
    <>
      <div>
        <div className={style.text_wrapper}>
          <p className={style.text}>{title}</p>
        </div>
        <div dir={direction}>
          <Select
            className={style.select}
            optionFilterProp="children"
            loading={props.loading}
            showSearch
            notFoundContent={props.loading ? "Loading roles..." : "No roles"}
            {...props}
            style={{ textTransform: "capitalize" }}
          />
        </div>
      </div>
    </>
  );
};

export default FormSelector;
